import { UtilService } from '$src/js/modules/base/services/UtilService';
import { TranslationService } from '$src/js/modules/base/services/TranslationService';
import { FocusTrapService } from '$src/js/modules/base/services/FocusTrapService';
import { KeyPressService } from '$src/js/modules/base/services/KeyPressService';
import { WindowResizeService } from '$src/js/modules/base/services/WindowResizeService';
import { ScrollService } from '$src/js/modules/base/services/ScrollService';

export default class BaseModule {
  private static instance: BaseModule | null = null;
  private _utils: UtilService | null = null;
  private _i18n: TranslationService | null = null;
  private _focusTrap: FocusTrapService | null = null;
  private _keypress: KeyPressService | null = null;
  private _windowResize: WindowResizeService | null = null;
  private _scroll: ScrollService | null = null;

  private bootModules = ['utils', 'i18n', 'focusTrap', 'windowResize', 'keypress', 'scroll'] as const;

  static getInstance(): BaseModule {
    BaseModule.instance ??= new BaseModule();
    return BaseModule.instance;
  }

  get utils(): UtilService {
    this._utils ??= new UtilService();
    return this._utils;
  }

  get i18n(): TranslationService {
    this._i18n ??= new TranslationService();
    return this._i18n;
  }

  get focusTrap(): FocusTrapService {
    this._focusTrap ??= new FocusTrapService();
    return this._focusTrap;
  }

  get windowResize(): WindowResizeService {
    this._windowResize ??= new WindowResizeService();
    return this._windowResize;
  }

  get keypress(): KeyPressService {
    this._keypress ??= new KeyPressService();
    return this._keypress;
  }

  get scroll(): ScrollService {
    this._scroll ??= new ScrollService();
    return this._scroll;
  }

  /**
   * Boot all modules
   */
  boot(): void {
    type ModuleKey = (typeof this.bootModules)[number];

    this.bootModules.forEach((module: ModuleKey) => {
      return this[module];
    });
  }
}
